'use strict';exports.__esModule = true;exports.default = {
  license: function license(value, previousValue) {
    if (isNaN(value)) {
      return previousValue;
    }
    if (value === '') {
      return value;
    }
    if (value.length > 9) {
      return previousValue;
    }
    return value;
  } };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/normalizers/editProfile.js
// module id = 3052
// module chunks = 0